import RpcService   from '@/core/services/Rpc/RpcService';
import RpcResponse   from '@/core/services/Rpc/RpcResponse';

import type CharacteristicAllowedValue from '@/domains/Characteristics/CharacteristicAllowedValue';
import type RpcDataPagination          from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort                from '@/core/services/Rpc/RpcDataSort';

class CharacteristicAllowedValuesDAO {

	static async getList(
		filters?: {
      id?: number;
      characteristicId?: number;
      name?: string;
      isDeleted?: boolean;
    },
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'characteristics.getAllowedValuesList',
			filters,
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}

	static async add(characteristicId: number, name: string): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.addAllowedValue', {
			characteristicId,
			name,
		});
	}

	static async update(value: CharacteristicAllowedValue): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.updateAllowedValue', { value });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.deleteAllowedValue', { id });
	}
}

export default CharacteristicAllowedValuesDAO;
